export enum PositionStateFilter {
    All = 0,
    Open = 1,
    Closed = 2,
}
